import styled from "styled-components";

export const ReservationStateWrapper = styled.div`
  width: calc(100% - 52px);
  height: 477px;
  border-radius: 12px;
  padding: 30px 15px 60px;
  background: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

export const ReservationStateHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > .title {
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;
    color: var(--Black-500, #202020);
  }
`;

export const ReservationStateTableWrapper = styled.div`
  margin: 20px 0;
  flex-direction: column;
  gap: 5px;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  color: #121212;

  .no {
    width: 87px;
  }

  .nickname {
    flex: 1;
  }
`;

export const ReservationTableHeader = styled.div`
  display: flex;
  background: #ddd1ff;
  width: 100%;
  height: 27px;
  border-radius: 10px;
  padding: 5px 10px;
  box-sizing: border-box;

  div:first-child {
    border-right: 0.5px solid #f0f0f0;
  }
`;

export const ReservationStateItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 270px;
  margin-top: 5px;
`;

export const ReservationStateItem = styled.div`
  display: flex;
  padding: 5px 10px;
  width: 100%;
  height: 27px;
`;
